import { createElement } from '@gn-audio/core/common/templating';
import './basket-engraving-validation-message.component.scss';
import template from './basket-engraving-validation-message.component.html';
var BasketEngravingValidationMessageComponent = /** @class */ (function () {
    function BasketEngravingValidationMessageComponent() {
    }
    Object.defineProperty(BasketEngravingValidationMessageComponent.prototype, "type", {
        /** Gets validation message type of current component */
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    BasketEngravingValidationMessageComponent.prototype.render = function (_a) {
        var container = _a.container, data = _a.data, type = _a.type;
        this._type = type;
        this.element = createElement(template, { message: data, type: type }, {});
        container.append(this.element);
    };
    BasketEngravingValidationMessageComponent.prototype.destroy = function () {
        var _a;
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
    };
    return BasketEngravingValidationMessageComponent;
}());
export { BasketEngravingValidationMessageComponent };
